import React, { Component } from 'react';
import { Redirect } from 'react-router'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrashAlt, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

import Filterable from '../components/ui/filter/Filterable.js';
import Form from '../components/farm/field/form.js';
import Summary from '../components/farm/field/summary.js';
import Box from '../components/ui/Box.js';
import Loading from '../components/ui/loading/Loading.js';

import FarmForm from '../components/farm/form.js';
import ConfirmUI from '../components/ui/Confirm.js';
//import HarvestChart from '../components/charts/HarvestChart.js';
import CostsChartGroup from '../components/charts/CostsChartGroup.js';

import api from '../api/index.js';

import './Dashboard.scss'

class Page extends Component {
	constructor(props) {
		super(props);
		this.state = {
			children: false,
			redirect: false,
			owner: false,
			editFormOpen: false
		};
		
		this.selectChild = this.selectChild.bind(this);
		this.onAddSubmit = this.onAddSubmit.bind(this);
		this.editFormOpen = this.editFormOpen.bind(this);
		this.editFormClose = this.editFormClose.bind(this);
		this.farmUpdated = this.farmUpdated.bind(this);
		this.discontinueFarmClick = this.discontinueFarmClick.bind(this);
		this.deleteFarmClick = this.deleteFarmClick.bind(this);
		this.discontinueFarm = this.discontinueFarm.bind(this);
		this.deleteFarm = this.deleteFarm.bind(this);
	}

	async refreshChildren() {
		try {
			let data = await api.get('farms/' + this.props.match.params.farm_id + '/fields/?from=' + this.props.dateStart.api() + '&until=' + this.props.dateEnd.api());
			data = data.map((a) => {
				a['discontinued'] = api.isCurrentlyDisabled(a.DiscontinuedDate);
				return a;
			});
			data = data.sort((a, b) => {
				if (a.discontinued && !b.discontinued)
					return 1;
				if (!a.discontinued && b.discontinued)
					return -1;
				if (a.FarmName > b.FarmName)
					return 1;
				if (a.FarmName < b.FarmName)
					return -1;
				return 0;
			});
			this.setState({children: data});
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	async refreshOwner() {
		try {
			let data = await api.get('farms/' + this.props.match.params.farm_id);
			data[0]['discontinued'] = api.isCurrentlyDisabled(data[0].DiscontinuedDate);
			this.setState({owner: data[0]});
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	async discontinueFarm() {
		try {
			await api.put('farms/' + this.props.match.params.farm_id + '/discontinue');
			this.setState({redirect: '/'});
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	async deleteFarm() {
		try {
			await api.del('farms/' + this.props.match.params.farm_id);
			this.setState({redirect: '/'});
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	
	farmUpdated(id) {
		this.refreshOwner();
		this.editFormClose();
	}
	
	componentDidMount() {
		this.refreshChildren();
		this.refreshOwner();
	}
	
	selectChild(data) {
		this.setState({redirect: '/farm/' + this.props.match.params.farm_id + '/field/' + data.FarmID});
	}
	
	async onAddSubmit(e) {
		this.setState({redirect: '/farm/' + this.props.match.params.farm_id + '/field/' + e});
		return true;
	}
	
	editFormClose() {	this.setState({editFormOpen: false}); }
	editFormOpen() {	this.setState({editFormOpen: true}); }
	
	
	discontinueFarmClick() {
		confirmAlert({
			title: 'Discontinue this farm: '  + this.state.owner.FarmName,
			customUI: ConfirmUI(
				this.discontinueFarm, 
				<div><p>This will remove the farm from your lists, but it'll be preserved in historical data.  It is the safest way to be rid of a farm.</p><p><em>Are you sure to discontinue this farm?</em></p></div>
			),
		});

	}
	
	deleteFarmClick() {
		/*confirmAlert({
			title: 'Permanently delete this farm: '  + this.state.owner.FarmName,
			message: 'This is not a safe action.  Only do this if you\'ve entered this farm by mistake and never used it otherwise.  If you have used it, you will be leaving orphaned data.',
			buttons: [
				{
					label: 'Yes',
					onClick: this.deleteFarm,
					className: 'error'
				},
				{
					label: 'No',
					onClick: () => {}
				}
			]
		});*/
		confirmAlert({
			title: 'Permanently delete this farm: '  + this.state.owner.FarmName,
			customUI: ConfirmUI(
				this.deleteFarm, 
				<div><p className="red"><em><strong>This is not a safe action.</strong></em></p><p>Avoid this unless you've entered a farm by mistake. Are you sure you want to do this?</p></div>
			),
		});
	}
	
	
	componentDidUpdate(priorProps) {
		if (priorProps.dateStart !== this.props.dateStart || priorProps.dateEnd !== this.props.dateEnd) {
			this.refreshChildren();
			this.refreshOwner();
		}
	}
	
	render() {
		if (this.state.redirect)
			return  <Redirect to={this.state.redirect} />
	
		if (this.state.owner === false)
			return <Loading />;

		// <HarvestChart dateStart={this.props.dateStart} dateEnd={this.props.dateEnd} farm={this.props.match.params.farm_id} />

		return <div className="Farm Specific">
				<Box title={this.state.owner.FarmName} modalTitle="Farm actions" options={[
					{
						label: <span><FontAwesomeIcon icon={faEdit} className="editIcon" /> Edit this farm's info</span>,
						callback: this.editFormOpen,
						separator: this.state.owner.discontinued
					},
					this.state.owner.discontinued ? false : {
						label: <span><FontAwesomeIcon icon={faTrashAlt} className="deleteIcon" /> Discontinue this farm</span>,
						callback: this.discontinueFarmClick,
						separator: true
					},
					{
						label: <span><FontAwesomeIcon icon={faExclamationTriangle} className="exclaimIcon" /> <small>Actually <strong>delete</strong> this farm from the system</small></span>,
						callback: this.deleteFarmClick
					},
				]}>
					<div className="widget-holder">
					<CostsChartGroup dateStart={this.props.dateStart} dateEnd={this.props.dateEnd} farm={this.props.match.params.farm_id}/>
					</div>
				</Box>
				<Filterable 
					summaryComponent={Summary}
					addForm={Form}
					onAddSubmit={this.onAddSubmit}
					children={this.state.children}
					onSelect={this.selectChild}
					addProps={{FarmID: this.state.owner.FarmID}}
					type="field"
					dateEnd={this.props.dateEnd}
				/>
				{this.state.editFormOpen && (
					<Box title={"Update " + this.state.owner.FarmName} modal={true} isOpen={this.state.editFormOpen} onRequestClose={this.editFormClose} >
						<FarmForm {...this.state.owner} onUpdated={this.farmUpdated} />
					</Box>)
				}
			</div>;
	}
}

export default Page;